// extracted by mini-css-extract-plugin
module.exports =  {"layout":"_0d624b9a27--layout--TjvSZ","spinner":"_0d624b9a27--spinner--uIpxO","container":"_0d624b9a27--container--O_TQ1","error":"_0d624b9a27--error--bfnyQ"};